import { Component, input, output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Client, ClientText, SetupWizardClientFormPayload } from '@mira-avant/mtlibs';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { TextField } from '../../../fields/setup-wizard/text-field/text-field';

type ClientForm = {
	name: FormControl<string | null>;
};

@Component({
	selector: 'app-setup-wizard-client-form',
	imports: [ReactiveFormsModule, NzButtonModule, NzFormModule, NzInputModule, NzSpinModule, TextField],
	standalone: true,
	templateUrl: './setup-wizard-client-form.html',
	styleUrl: './setup-wizard-client-form.scss',
})
export class SetupWizardClientForm {
	public loading = input<boolean>(false);
	public onSubmit = output<SetupWizardClientFormPayload>();
	public edit = input<Client | null>(null);

	public form = new FormGroup<ClientForm>({
		name: new FormControl<string | null>(null, {
			nonNullable: false,
			validators: [Validators.required, Validators.minLength(2)],
		}),
	});

	ngOnChanges(changes: SimpleChanges) {
		const edit = this.edit();

		//Are the changes the edit value?
		const editChange = changes['edit'];

		if (editChange && editChange.currentValue) {
			const firstText: ClientText = editChange.currentValue.client_text[0];

			if (firstText) {
				this.form.patchValue({
					name: firstText.name,
				});
			}
		}
	}

	onFormSubmit() {
		if (this.form.valid) {
			this.onSubmit.emit(this.form.getRawValue());

			// this.form.reset(); // if you want to clear after submit
		} else {
			this.form.markAllAsTouched();
		}
	}
}
